export default __webpack_public_path__ + "static/icons-final-47b1bac4196ab7e3b0851fe087536f3d.png";